module.exports = __webpack_public_path__ + "img/zx2.d4f228bb.png";